<div class="captcha-container">
  <div #mount class="fc-wrapper" (click)="handleClick()"></div>
</div>
